



















































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import ReceiptDialogComponent from '@/components/ReceiptDialogComponent.vue'
import LabelPrintDialogComponent from '@/components/LabelPrintDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { Request } from '@/domain/Request'
import { User } from '@/domain/User'
import { WindowPosition } from '@/domain/WindowPosition'
import RequestsService, { SerchConditon } from '@/service/RequestsService'
import LabelPrintService from '@/service/LabelPrintService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    ReceiptDialogComponent,
    LabelPrintDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberRequestList extends Mixins(GlobalMixin) {
  requestsService = RequestsService.instance
  labelPrintService = LabelPrintService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "依頼日", value: "requestOn", width: "100px" },
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "120px" },
          { text: "検体識別記号", value: "specimenId", width: "130px" },
          { text: "着予定日", value: "arriveOn", width: "100px" },
          { text: "重量", value: "weight", align: "end", width: "100px" },
          { text: "着日", value: "receiptOn", width: "100px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "報告予定日", value: "deliveryOn", width: "110px" },
          { text: "報告日", value: "reportOn", width: "100px" },
          { text: "他文書", value: "links", filterable: false, sortable: false, width: "160px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "160px" },
  ]
  list: Request[] = []
  selectItems: Request[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  itemKey = ""

  /** 検体受取ダイアログ */
  receiptDialog = false

  /** ラベル印刷枚数ダイアログ */ 
  labelPrintRequest = new Request()
  labelPrintDialog = false

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}`)
    const distinct = [...new Set(keys)]
    return distinct.length === 1
  }

  /**
   * 見積ボタンの無効
   */
  get disableEstimate() {
    return this.selectItems.filter(x => x.estimateNo !== "").length !== 0
  }

  /**
   * 複写作成ボタンの無効
   */
  get disableRequestCopy() {
    return this.selectItems.length !== 1
  }

  /**
   * 請書ボタンの無効
   */
  get disableConfirmation() {
    return this.selectItems.filter(x => x.confirmationNo !== "").length !== 0
  }

  /**
   * 請求書ボタンの無効
   */
  get disableInvoice() {
    return this.selectItems.filter(x => x.invoiceCompleted).length !== 0
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.request.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.request.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.request.list.conditions", JSON.stringify(this.conditions))
    this.requestsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.request.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Request): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Request) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.requestNo) {
      this.$router.push(`/member/request/edit/${event.requestNo}`)
    }
    this.rowItemKey = event.requestNo
    this.rowItemClickTime = now
  }

  /**
   * ラベル印刷ボタン
   */
  onPrintLabel(request: Request) {
    this.labelPrintRequest = request
    this.labelPrintDialog = true;
  }

  /**
   * ラベル印刷実行
   */
  onLabelPrint(event: number) {
    this.showLoading()
    const storagePeriod = this.dateUtils.lastDate(this.dateUtils.addMonth(this.labelPrintRequest.receiptOn, 4))
    const classificationName = this.labelPrintRequest.sumInfo.classificationNames.ellipsis(8)
    const receiptUser = this.labelPrintRequest.receiptUser.userName
    this.labelPrintService.print(this.labelPrintRequest.requestNo, this.labelPrintRequest.receiptOn, receiptUser, classificationName, storagePeriod, this.labelPrintRequest.specimenReturn, event)
      .then((status) => {
        if (status === true) {
          this.alert(`検体ラベルを${event}枚印刷しました`, ALERT_TYPE.SUCCESS)
        } else {
          this.alert("検体ラベルの印刷に失敗しました", ALERT_TYPE.ERROR)
        }
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検体ラベルの印刷に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 検体受取
   */
  // eslint-disable-next-line
  onReceipt(requestNo: string) {
    this.itemKey = requestNo
    this.receiptDialog = true;
  }

  /**
   * 見積作成
   */
  onEstimate() {
    const query = this.selectItems.map(x => x.requestNo)
        .join(",")
    this.$router.push("/member/estimate/new?refs=" + query)
  }

  /**
   * 複写作成
   */
  onRequestCopy() {
    // eslint-disable-next-line
    const query = this.selectItems.map(x => x.requestNo).find(x => true)
    this.$router.push("/member/request/new?copy=" + query)
  }

  /**
   * 請書作成
   */
  onConfirmation() {
    const query = this.selectItems.map(x => x.requestNo)
        .join(",")
    this.$router.push("/member/confirmation/new?refs=" + query)
  }

  /**
   * 請求書作成
   */
  onInvoice() {
    const query = this.selectItems.map(x => x.requestNo)
        .join(",")
    this.$router.push("/member/invoice/new?refs=" + query)
  }

  /**
   * 検体着日入力
   */
  onReceipted(event: [string, string, User, number]) {
    this.showLoading()
    const requestNo = event[0]
    const param = {receiptOn: event[1], receiptUserId: event[2].userId, receiptUserName: event[2].userName, weight: event[3]}
    this.requestsService.updateReceiptOn(requestNo, param)
      .then(() => {
        this.alert("検体着日を更新しました", ALERT_TYPE.SUCCESS)
        this.search()
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検体着日の更新に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
  
  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.request.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.request.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.request.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
